import gql from 'graphql-tag';
import * as Urql from 'urql';

import * as Types from './types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetBookingsExpandedWithLegsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Container_Insights_Bookings_Expanded_Bool_Exp>;
  order_by?: Types.InputMaybe<
    | Array<Types.Container_Insights_Bookings_Expanded_Order_By>
    | Types.Container_Insights_Bookings_Expanded_Order_By
  >;
}>;

export type GetBookingsExpandedWithLegsQuery = {
  __typename?: 'query_root';
  container_insights_bookings_expanded: Array<{
    __typename?: 'container_insights_bookings_expanded';
    internal_booking_id?: any | null;
    reefer_id?: string | null;
    start_gps?: any | null;
    end_gps?: any | null;
    start_datetime?: any | null;
    end_datetime?: any | null;
    manufacturer?: string | null;
    refrigeration_unit_model?: string | null;
    tradelane?: string | null;
    temperature_setpoint?: any | null;
    start_iso?: string | null;
    end_iso?: string | null;
    start_location?: string | null;
    start_long_location?: string | null;
    end_location?: string | null;
    end_long_location?: string | null;
    co2eq_kg?: any | null;
    legs: Array<{
      __typename?: 'container_insights_booking_legs';
      booking_id?: any | null;
      start_gps?: any | null;
      end_gps?: any | null;
      start_long_location?: string | null;
      end_long_location?: string | null;
      start_datetime?: any | null;
      end_datetime?: any | null;
      leg_expanded?: {
        __typename?: 'container_insights_legs_expanded';
        co2eq_kg?: any | null;
      } | null;
    }>;
  }>;
};

export const GetBookingsExpandedWithLegsDocument = gql`
  query GetBookingsExpandedWithLegs(
    $where: container_insights_bookings_expanded_bool_exp
    $order_by: [container_insights_bookings_expanded_order_by!]
  ) {
    container_insights_bookings_expanded(where: $where, order_by: $order_by) {
      internal_booking_id
      reefer_id
      start_gps
      end_gps
      start_datetime
      end_datetime
      manufacturer
      refrigeration_unit_model
      tradelane
      temperature_setpoint
      start_iso
      end_iso
      start_location
      start_long_location
      end_location
      end_long_location
      co2eq_kg
      legs {
        booking_id
        start_gps
        end_gps
        start_long_location
        end_long_location
        start_datetime
        end_datetime
        leg_expanded {
          co2eq_kg
        }
      }
    }
  }
`;

export function useGetBookingsExpandedWithLegsQuery(
  options?: Omit<
    Urql.UseQueryArgs<GetBookingsExpandedWithLegsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    GetBookingsExpandedWithLegsQuery,
    GetBookingsExpandedWithLegsQueryVariables
  >({ query: GetBookingsExpandedWithLegsDocument, ...options });
}
